import { render, staticRenderFns } from "./ReportNotify.vue?vue&type=template&id=53ff870f&"
import script from "./ReportNotify.vue?vue&type=script&lang=js&"
export * from "./ReportNotify.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotify.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports